import React from "react";
import { Link } from "react-router";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { Person } from "@domain/user/user";
import { fullName } from "@domain/user/utils";

interface NotificationSourceProps extends React.HTMLAttributes<HTMLAnchorElement> {
	source: Person;
}
export const NotificationSource: React.FC<NotificationSourceProps> = ({ source, ...htmlProps }) => {
	return (
		<Source {...htmlProps} to={source.type === "USER" ? Path.Profile(source) : Path.Organization(source)}>
			{fullName(source)}
		</Source>
	);
};
const Source = styled(Link)`
	${({ theme }) => theme.textStyles.primaryBold};
	color: ${({ theme }) => theme.textStyles.primary};
`;
